import { fetchBuildersProjectsData } from '../../services/fetchBuildersProjectsData';
import { TThunkAction } from '../../types/redux';
import { smoothScrollToPositionAsync } from '../../utils/scroll';
import { setBuildersProjectsData, startFetching } from '../buildersProjects';
import { DEFAULT_LIMIT, DEFAULT_PAGE } from '../../constants/pagination';
import { IFilters } from '../../types/filters';
import { transformFiltersToQueryString } from '../../utils/url';
import { trackPageView } from '../../utils/analytics';
import { selectLocationId } from '../../selectors/locations';
import { selectCurrentPage } from '../../selectors/pagination';
import { fetchSeoUrl } from '../../services/fetchSeoUrl';
import { updateSeoData } from '../seo';
import { updateUrl } from '../url';

interface IParams {
  filters?: IFilters;
  page?: number;
  limit?: number;
  shouldUpdateUrl?: boolean;
}

export const fetchBuildersProjects = ({
  filters,
  page = DEFAULT_PAGE,
  limit = DEFAULT_LIMIT,
  shouldUpdateUrl = true,
}: IParams): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    dispatch(startFetching());

    const state = getState();

    const regionId = selectLocationId(state);
    const currentPage = selectCurrentPage(state);

    const [data] = await Promise.all([
      fetchBuildersProjectsData(context, {
        ...filters,
        page,
        limit,
        regionId,
      }),
      smoothScrollToPositionAsync(0),
    ]);

    dispatch(setBuildersProjectsData(data));

    if (shouldUpdateUrl) {
      const queryString = transformFiltersToQueryString({ filters, page });

      const seoUrl = queryString
        ? await fetchSeoUrl(context, { subdomain: context.custom.subdomain, query: queryString })
        : undefined;

      const urlParams = {
        queryString,
        seoUrl,
      };

      await dispatch(updateSeoData(urlParams));

      dispatch(updateUrl(urlParams));
    }

    if (data.page !== currentPage) {
      const { deviceType, userId } = context.custom;

      trackPageView({ buildersProjects: data, deviceType, userId });
    }
  };
};
